var map = {
	"./10.png": 34102,
	"./2.png": 31719,
	"./3.png": 55934,
	"./4.png": 497,
	"./5.png": 52104,
	"./6.png": 14083,
	"./7.png": 24250,
	"./8.png": 93485,
	"./9.png": 13892,
	"./A.png": 44508,
	"./J.png": 37455,
	"./K.png": 55910,
	"./Q.png": 60940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55328;